module.exports = __webpack_public_path__ + "images/structure_fig4_11127fe.jpg";